import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { dataResultsDetailed } from "../utils/helpers";
import { TextContentInfo } from "../Components";
import TableResults from "../Components/Table/TableResults";
import { Box, Button, useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";

export default function DetailedResults() {
  const [currentPage, setCurrentPage] = useState(0);
  const [resultsPerPage, setResultsPerPage] = useState(100);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 960px)");
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleResultsPerPageChange = (event) => {
    setResultsPerPage(parseInt(event.target.value));
    setCurrentPage(0);
  };
  const [resultData, setResultData] = useState([]);
  const location = useLocation();
  const { config, role } = useSelector((state) => state.user);
  useEffect(() => {
    if (location.state?.data && location.state.data.length > 0) {
      setResultData(location.state.data);
    }
  }, [location.state?.data]);

  const noResultsFound = resultData.length === 0;
  const handleExit = () => {
    navigate(-1);
  };
  const patientInfo = location.state?.patientInfo;

  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "80%",
          flexDirection: "row",
          marginLeft: isMobile ? "5px" : "10%",
        }}
      >
        <TextContentInfo
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            marginLeft: "0 !important",
            "& .MuiBox-root": {
              marginLeft: "0 !important",
            },
            "& .MuiTypography-root": {
              marginLeft: "0",
            },
            "& .css-kg3fcp": { width: "80%" },
          }}
          text={
            !isMobile ? (
              <span
                style={{
                  fontSize: "25px",
                }}
              >
                Справка резултати
                <span
                  style={{
                    //marginLeft: "10px",
                    fontSize: "20px",
                    // fontWeight: "bold",
                    color: "#333",
                    marginLeft: "25px",
                  }}
                >
                  {patientInfo.GivenPacName}
                </span>
                <span
                  style={{
                    marginLeft: "5px",
                    fontSize: "20px",
                    // fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {patientInfo.MiddlePacName}
                </span>
                <span
                  style={{
                    marginLeft: "5px",
                    fontSize: "20px",
                    // fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {patientInfo.FamilyPacName}
                </span>
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "normal",
                    color: "#333",
                    marginLeft: "30px",
                  }}
                >
                  {role !== "patient" && "ЕГН:"} {patientInfo.IdentifierPac}
                </span>
              </span>
            ) : (
              <Box
                style={{
                  fontSize: "12px",
                }}
              >
                <Box>
                  <span
                    style={{
                      // marginLeft: "10px",
                      fontSize: "12px",
                      // fontWeight: "bold",
                      color: "#333",
                      marginLeft: 0,
                    }}
                  >
                    {patientInfo.GivenPacName}
                  </span>
                  <span
                    style={{
                      marginLeft: "5px",
                      fontSize: "12px",
                      // fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    {patientInfo.MiddlePacName}
                  </span>
                  <span
                    style={{
                      marginLeft: "5px",
                      fontSize: "12px",
                      // fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    {patientInfo.FamilyPacName}
                  </span>
                </Box>
                <Box>
                  <span
                    style={{
                      // marginLeft: "15px",
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#333",
                      marginLeft: 0,
                    }}
                  >
                    ЕГН: {patientInfo.IdentifierPac}
                  </span>
                </Box>
              </Box>
            )
          }
        />
        {!isMobile && (
          <Button
            onClick={handleExit}
            sx={{
              display: "inline-block",
              marginLeft: "auto",
              color: config.appBarColor,
            }}
          >
            X
          </Button>
        )}
      </div>

      <TableResults
        results={resultData}
        resultCell={["TechGroupName", "Result"]}
        currentPage={currentPage}
        resultsPerPage={resultsPerPage}
        handlePageChange={handlePageChange}
        handleResultsPerPageChange={handleResultsPerPageChange}
        text={dataResultsDetailed}
        noResultsFound={noResultsFound}
      />
    </Fragment>
  );
}
